// SERVER ROUTES
export const BASE_URL = (process.env.NODE_ENV === 'production') ? process.env.REACT_APP_BASE_URL_PRODUCTION : process.env.REACT_APP_BASE_URL;
export const USER_SERVER = `${BASE_URL}/api/users`;
export const PRODUCT_SERVER = `${BASE_URL}/api/product`;
export const ORDER_SERVER = `${BASE_URL}/api/orders`;
export const SITE_SERVER = `${BASE_URL}/api/site`;
// export const S3_URL = 'https://s3.amazonaws.com/juzbi/';
export const S3_URL = process.env.REACT_APP_S3_URL;

export const POS_ORDER_SERVER = '/api/pos/orders';